import { useEffect, useState } from "react";
// import { TokenManager } from '../auth/token-manager';

// const tokenManager = TokenManager.getInstance();

const ProtectedRoute = ({ permissionCheck, appRefName, appName, children }) => {
    const [hasPermission, setHasPermission] = useState(null);
    // const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    useEffect(() => {
        setHasPermission(null);
        // setIsCheckingAuth(true);

        const checkPermission = async () => {
            try {
                const result = await permissionCheck(appRefName);
                setHasPermission(result);
            } catch {
                setHasPermission(false);
            }
        };

        //while (attempts < maxAttempts) {
        //    const token = tokenManager.getToken();

        //    if (token) {
        //        // Token available, now check permission
        //        setIsCheckingAuth(false);

        //        try {
        //            const result = await permissionCheck(appRefName);
        //            setHasPermission(result);
        //        } catch (error) {
        //            console.error('Permission check failed:', error);
        //            setHasPermission(false);
        //        }
        //        return;
        //    }

        //    // Wait 100ms and try again
        //    await new Promise(resolve => setTimeout(resolve, 100));
        //    attempts++;
        //}

        checkPermission();
    }, [permissionCheck, appRefName]);

    if (hasPermission === null) {
        // if (isCheckingAuth || hasPermission === null) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '200px'
            }}>
                <div>Loading...</div>
            </div>
        );
    }

    if (!hasPermission) {
        return <div style={{ margin: 20 }}>
            <h4>You do not have access to {appName}.</h4>
            <p>
                If you need access to this application, please submit a ticket via the&nbsp;
                <b>
                    <a href="https://surgerypartners.service-now.com/sp?id=sc_cat_item&sys_id=0bce7feddba5be4000025dd5ce96191a&sysparm_category=7bdf1ee4db6e9410df2f5dd5ce96191f" target="_new">ServiceNow Service Portal</a>.
                </b>
            </p>
        </div>;
    }

    return children;    
};

export default ProtectedRoute;